module.exports = __webpack_public_path__ + "static/INTRAMETHOME-e2a2fc1e35aceef51df7325c574344e9.mp4";